// extracted by mini-css-extract-plugin
module.exports = {"bgLoading":"bgLoading___1R6CZ"};